import { CloudFile } from 'owa-attachment-file-types';
import { getProviderBrandName } from 'owa-fileprovider-store';
import loc, { format } from 'owa-localize';
import {
    InsertLinkFailureInfoText,
    InsertLinkFailureInsufficientPermissionText,
} from './insertLink.locstring.json';
import { assertNever } from 'owa-assert';
import { InsertLinkFailureType } from '../types/InsertLinkFailureType';
import getInsertLinkViewState from '../selectors/getInsertLinkViewState';

function getInsertLinkFailureType(linkId: string): InsertLinkFailureType {
    const viewState = getInsertLinkViewState(linkId);
    return !!viewState ? viewState.insertFailureType : InsertLinkFailureType.Unknown;
}

export function getInsertLinkFailureInfo(file: CloudFile, lindId: string): string {
    const providerBrandName: string = getProviderBrandName(file.providerType);
    let failureText: string = '';
    const failureType: InsertLinkFailureType = getInsertLinkFailureType(lindId);
    switch (failureType) {
        case InsertLinkFailureType.Unknown:
        case InsertLinkFailureType.GenericFailure:
            failureText = InsertLinkFailureInfoText;
            break;
        case InsertLinkFailureType.InsufficientFilePermissions:
            failureText = InsertLinkFailureInsufficientPermissionText;
            break;
        default:
            return assertNever(failureType);
    }

    return format(loc(failureText), file.name, providerBrandName);
}
